exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".alert_events {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.alert_events_icon {\n  color: #bbbcc1 !important;\n  margin-left: 10px;\n}", ""]);

// exports
